import { render, staticRenderFns } from "./CentralItemsContainer.vue?vue&type=template&id=627da039&scoped=true&"
import script from "./CentralItemsContainer.vue?vue&type=script&lang=js&"
export * from "./CentralItemsContainer.vue?vue&type=script&lang=js&"
import style0 from "./CentralItemsContainer.vue?vue&type=style&index=0&id=627da039&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "627da039",
  null
  
)

export default component.exports